<template>
  <section class="picture-feed">
    <div class="container">
      <h1 class="picture-feed--title">{{ title }}</h1>
      <h4 class="picture-feed--subtitle">{{ subtitle }}</h4>
    </div>
    <article class="picture-feed--gallery">
      <div ref="feed" class="picture-feed--gallery-wrapper">
        <KenticoImage v-for="(image,index) in images" :key="`image-${index}`" :src="image.url" class="picture-feed--gallery-item" :class="`image-${index}`" />
      </div>
    </article>
  </section>
</template>
<script>
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { gsap, CSSPlugin } from 'gsap';
import debounce from 'lodash.debounce';
export default {
  props: {
    title: { type: String, default: '', required: true },
    subtitle: { type: String, default: '', required: true },
    images: { type: Array, default: null, required: false },
  },
  data() {
    return {
      scroller: null,
    };
  },
  mounted() {
    this.animate();
    gsap.registerPlugin(CSSPlugin);
    gsap.registerPlugin(ScrollTrigger);
    this.debouncedAnimate = debounce(this.handleResize, 100);
    window && window.addEventListener('resize', this.debouncedAnimate);
  },
  beforeDestroy() {
    window && window.removeEventListener('resize', this.debouncedAnimate);
  },
  methods: {
    handleResize() {
      this.scroller.scrollTrigger.kill();
      this.animate();
    },
    animate() {
      const { feed } = this.$refs;
      const width = feed.clientWidth - window.innerWidth;
      this.scroller = gsap.to(feed, {
        x: -width,
        scrollTrigger: {
          trigger: feed,
          scrub: true,
          start: 'bottom bottom',
          end: () => '+=' + width,
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import '~/assets/scss/atomic/modules/_picture-feed.scss';
</style>
